import { resolveLegacyMenuUrl } from './legacy-menu-url.js'

/**
 * Destino del botón de validación de nómina que el remote de Credenciales dispara vía
 * `onNavigateToNomina`. El ítem "Nómina" del menú principal no pasa por acá: usa la URL que entrega
 * el backend para ese nodo.
 *
 * Nómina no se despliega en todos los ambientes. Mientras un ambiente siga usando la pantalla del
 * PHP legacy, define `VITE_LEGACY_NOMINA_URL` con esa URL (build-time) y se resuelve esa URL; si la
 * variable no está definida, si el pipeline entrega el macro sin expandir o si el valor no es una
 * URL absoluta, se devuelve `fallbackRoute` (el comportamiento previo al fix).
 *
 * @param {string} fallbackRoute Destino a usar cuando no hay URL legacy válida.
 * @returns {string} URL absoluta del PHP legacy, o el fallback.
 */
export function resolveNominaUrl(fallbackRoute) {
  return resolveLegacyMenuUrl(import.meta.env.VITE_LEGACY_NOMINA_URL, fallbackRoute)
}
